import React from 'react';
import { makeStyles } from '@material-ui/core';
import { ReactComponent as Icon } from '#web-components/assets/icons/editOutlined.svg';

import styles from './EditOutlinedIcon.styles';

const useStyles = makeStyles(styles, { name: 'EditOutlinedIcon' });

export default function EditOutlinedIcon() {
  const classes = useStyles();
  return (
    <span className={classes.editIcon}>
      <Icon />
    </span>
  );
}
